/* eslint-disable */
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { LoadingIndicator } from "./utils";
import { PaycheckContextProvider, ThemeContextProvider } from "./contexts";
import DependentsContextProvider from "./contexts/dependentContext/provider";

import { ADMIN_ENV } from "./config/config";
if (ADMIN_ENV === "PROD") {
	console.log = () => { };
	console.warn = () => { };
	console.error = () => { };
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
	<React.StrictMode>
		<LoadingIndicator />
		<PaycheckContextProvider>
			<ThemeContextProvider>
				<DependentsContextProvider>
					<App />
				</DependentsContextProvider>
			</ThemeContextProvider>
		</PaycheckContextProvider>
	</React.StrictMode>
);
